import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { SystemSection } from './components/SystemSection';
import { MainProduct } from './components/MainProduct';
import { Bonuses } from './components/Bonuses';
import { FitSection } from './components/FitSection';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { Comparison } from './components/Comparison';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { PurchaseToast } from './components/PurchaseToast';
export function App() {
  return <div className="w-full bg-night font-sans text-parchment" data-id="element-0" data-mp="28sl3uyeo7ofi">
      <Hero data-id="element-1" data-mp="23w4ek0vqj40u" />
      <main data-id="element-2" data-mp="23ujk0b9f7l2z">
        <Testimonials data-id="element-3" data-mp="23utadzydnu97" />
        <PainPoints data-id="element-4" data-mp="23ti864kkyuk7" />
        <SystemSection data-id="element-5" data-mp="3ik7eyd5x05p2" />
        <MainProduct data-id="element-6" data-mp="3iiwdwl3utc1n" />
        <Bonuses data-id="element-7" data-mp="3ijfvg0pldyf5" />
        <FitSection data-id="element-8" data-mp="3ihv0i9zd8dgr" />
        <Urgency data-id="element-9" data-mp="3mlj6wpc9h30f" />
        <Pricing data-id="element-10" data-mp="3ml17xky7saot" />
        <Guarantee data-id="element-11" data-mp="3mkhou0wtvg97" />
        <Faq data-id="element-12" data-mp="3mjq1fdddwou0" />
        <Comparison data-id="element-13" data-mp="3mjg93j4va5l5" />
        <FinalCta data-id="element-14" data-mp="3rc9i4j7dc031" />
      </main>
      <Footer data-id="element-15" data-mp="3rdapodp6e4g0" />
      <StickyCta data-id="element-16" data-mp="3rdkkqfp2v1sk" />
      <PurchaseToast data-id="element-17" data-mp="3rd17vdeab3le" />
    </div>;
}